var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDevicesMonitoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348 4839 c-111 -26 -242 -127 -292 -227 -58 -115 -56 -58 -56 -1392 0 -1335 -1 -1299 57 -1400 53 -92 143 -169 248 -211 l60 -24 582 -3 582 -3 -5 -32 c-7 -52 -54 -433 -54 -440 0 -4 -74 -7 -164 -7 -136 0 -175 -3 -229 -20 -110 -34 -202 -117 -256 -230 -23 -49 -26 -67 -26 -165 0 -98 3 -116 26 -165 54 -113 146 -196 256 -230 64 -20 89 -20 1847 -20 1962 0 1839 -4 1953 61 71 41 143 115 181 187 65 122 62 37 62 1554 0 989 -3 1392 -11 1430 -32 148 -152 293 -284 343 l-45 18 0 302 c0 270 -2 310 -19 364 -46 149 -168 267 -316 305 -53 14 -282 16 -2060 15 -1118 -1 -2017 -5 -2037 -10z m4049 -329 c61 -37 63 -50 63 -355 l0 -275 -567 0 c-605 0 -611 -1 -718 -51 -65 -30 -175 -139 -209 -208 -55 -107 -56 -120 -56 -953 l0 -768 -1237 0 c-1382 0 -1281 -5 -1330 69 l-23 34 0 1211 c0 1154 1 1213 18 1245 10 19 34 43 53 53 32 17 115 18 2004 18 1936 0 1971 0 2002 -20z m323 -972 c18 -13 43 -36 54 -51 l21 -28 0 -1384 0 -1384 -21 -28 c-11 -15 -36 -38 -54 -51 l-34 -22 -677 2 c-666 3 -678 3 -706 24 -15 11 -38 40 -50 64 l-23 44 0 1351 0 1351 23 44 c12 25 37 55 56 67 l34 23 672 0 672 0 33 -22z m-1810 -2198 l0 -240 -560 0 -561 0 6 33 c4 27 55 433 55 444 0 2 239 3 530 3 l530 0 0 -240z m0 -592 c0 -18 6 -61 14 -95 l13 -63 -884 0 -885 0 -29 29 c-21 22 -29 39 -29 66 0 27 8 44 29 66 l29 29 871 0 871 0 0 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3909 1257 c-111 -59 -154 -195 -99 -307 43 -85 107 -124 206 -125 61 0 77 4 119 30 31 19 61 49 80 79 55 89 37 213 -42 288 -65 62 -183 77 -264 35z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesMonitoring);
export default __webpack_public_path__ + "static/media/devicesMonitoring.2c73c7560df96305c38a9537436a8603.svg";
export { ForwardRef as ReactComponent };